<div class="pt-4 flex flex-col gap-4">

  <!-- App header photo -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.app-header' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-image-field
        [currentImageName]="appHeaderPhotoName()"
        [currentImageUrl]="appHeaderPhotoUrl()"
        (fileSelected)="uploadImage.emit({ type: WaterInfoImageType.AppHeader, file: $event })"
        (cleared)="deleteImage.emit(WaterInfoImageType.AppHeader)"
      />
    </mat-card-content>
  </mat-card>

  <!-- Short description -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.short-description' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.shortDescriptionNl"
        [en]="form.controls.shortDescriptionEn"
        [de]="form.controls.shortDescriptionDe"
        [it]="form.controls.shortDescriptionIt"
        [fr]="form.controls.shortDescriptionFr"
      />
    </mat-card-content>
  </mat-card>

  <!-- USPs -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.usps' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-list-editor
        [nl]="form.controls.uspsNl"
        [en]="form.controls.uspsEn"
        [de]="form.controls.uspsDe"
        [it]="form.controls.uspsIt"
        [fr]="form.controls.uspsFr"
      />
    </mat-card-content>
  </mat-card>

  <!-- Rules -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.rules' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-list-editor
        [nl]="form.controls.rulesNl"
        [en]="form.controls.rulesEn"
        [de]="form.controls.rulesDe"
        [it]="form.controls.rulesIt"
        [fr]="form.controls.rulesFr"
      />
    </mat-card-content>
  </mat-card>

  <!-- Info pack -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.info-pack' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-list-editor
        [nl]="form.controls.infoPackNl"
        [en]="form.controls.infoPackEn"
        [de]="form.controls.infoPackDe"
        [it]="form.controls.infoPackIt"
        [fr]="form.controls.infoPackFr"
      />
    </mat-card-content>
  </mat-card>

  <!-- Place -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.place' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4">
      <app-localized-text-editor
        [nl]="form.controls.placeNl"
        [en]="form.controls.placeEn"
        [de]="form.controls.placeDe"
        [it]="form.controls.placeIt"
        [fr]="form.controls.placeFr"
      />
    </mat-card-content>
  </mat-card>

  <!-- Ambiance video + poster image -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.ambiance-video' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4 flex flex-col gap-4">
      <app-localized-text-editor
        [nl]="form.controls.ambianceVideoNl"
        [en]="form.controls.ambianceVideoEn"
        [de]="form.controls.ambianceVideoDe"
        [it]="form.controls.ambianceVideoIt"
        [fr]="form.controls.ambianceVideoFr"
      />
      <div>
        <p class="text-sm text-gray-600 dark:text-gray-400 mb-2">{{ 'waters.information.ambiance-poster' | translate }}</p>
        <app-image-field
          [currentImageName]="ambianceVideoImageName()"
          [currentImageUrl]="ambianceVideoImageUrl()"
          (fileSelected)="uploadImage.emit({ type: WaterInfoImageType.AmbiancePoster, file: $event })"
          (cleared)="deleteImage.emit(WaterInfoImageType.AmbiancePoster)"
        />
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Expectations -->
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{ 'waters.information.section.expectations' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="!pt-4 !flex flex-col gap-6">
      @for (exp of expectations(); track $index; let expIndex = $index) {
        <div class="border rounded p-3 flex flex-col gap-2">
          <div class="flex justify-between items-center">
            <mat-checkbox [checked]="exp.available" (change)="setExpectationAvailable(expIndex, $event.checked)">
              {{ 'waters.information.expectation.available' | translate }}
            </mat-checkbox>
            <button
              mat-icon-button
              type="button"
              color="warn"
              [aria-label]="'generic.remove' | translate"
              [matTooltip]="'generic.remove' | translate"
              (click)="removeExpectation(expIndex)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-5 gap-2">
            @for (lang of langs; track lang) {
              <mat-form-field>
                <mat-label>{{ lang.toUpperCase() }}</mat-label>
                <input
                  matInput
                  [value]="$any(exp)['text' + lang.charAt(0).toUpperCase() + lang.slice(1)] ?? ''"
                  (change)="setExpectationText(expIndex, lang, $any($event.target).value)"
                />
              </mat-form-field>
            }
          </div>
        </div>
      }
      <button mat-stroked-button type="button" class="self-start" (click)="addExpectation()">
        <mat-icon>add</mat-icon>
        {{ 'waters.information.add-expectation' | translate }}
      </button>
    </mat-card-content>
  </mat-card>

</div>
